module.exports = __webpack_public_path__ + "img/253.effe51cc.png";